<template>
  <div class="page-container">
    <TableList
      :columns="tabPaneConfig[0].columns"
      :tableData="tabPaneConfig[0].tableData"
      :loading="tabPaneConfig[0].loading"
      :scroll="{}"
      :pagination="tabPaneConfig[0].pagination"
      @change="handleTableChange"
    >
      <div slot="queryArea" style="margin-bottom: 20px">
        <!--        <j-dict-select-tag-->
        <!--          placeholder="请选择年级"-->
        <!--          v-model="queryParam.gradeId"-->
        <!--          style="width: 140px; margin-right: 15px"-->
        <!--          dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"-->
        <!--          allowClear-->
        <!--        />-->
        <j-dict-select-tag
          style="width: 170px; margin-right: 15px"
          placeholder="请选择年级"
          v-model="queryParam.gradeId"
          dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
          :isShowEmpty="false"
          allowClear
          @select="$set(queryParam, 'classId', undefined)"
        />
        <j-dict-select-tag
          style="width: 170px; margin-right: 15px"
          placeholder="请选择班级"
          v-model="queryParam.classId"
          :dictCode="
            'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
          "
          :async="true"
          :disabled="!queryParam.gradeId"
          :isShowEmpty="false"
        />
        <!--        <j-dict-select-tag-->
        <!--          placeholder="请选择班级"-->
        <!--          v-model="queryParam.classId"-->
        <!--          style="width: 140px; margin-right: 15px"-->
        <!--          :dictCode="-->
        <!--            'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)-->
        <!--          "-->
        <!--          :async="true"-->
        <!--        />-->
        <a-input-search
          v-model="queryParam.studentName"
          placeholder="请输入学生名称"
          style="width: 200px; margin-right: 15px"
          @change="searchName"
        />
        <a-button type="primary" @click="queryTable">查询</a-button>
        <!-- <a-button type="primary" icon="plus">新增</a-button> -->
        <a-button
          type="primary"
          icon="download"
          style="margin: 0 15px"
          @click="handleExportXls('心理评估列表')"
        >
          导出
        </a-button>
      </div>
      <template slot="action" slot-scope="{ record }">
        <div class="action-detail">
          <span @click="seeReport(record)">查看报告</span>
          <a-divider type="vertical" />
          <span @click="assessClick(record)">评估</span>
          <a-divider type="vertical" />
          <span @click="viewArchives(record)">查看档案</span>
        </div>
      </template>
    </TableList>
    <!-- 评估 -->
    <AssessModal ref="assessModalRef" />
    <!--    数据报告-->
    <DetailedReport ref="detailedReportRef" />
    <TeacherAssessment ref="teacherAssessmentRef" />
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import { getAction } from '@api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { simpleDebounce } from '@/utils/util'
import AssessModal from '@/comUi/AssessModal'
import TeacherAssessment from './components/TeacherAssessment.vue'
import DetailedReport from '@/comUi/ArchivesView/components/DetailedReport'

const tablePagination = {
  current: 1,
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100'],
  showTotal: (total, range) => {
    return range[0] + '-' + range[1] + ' 共' + total + '条'
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
}

export default {
  name: 'MindAssessment',
  mixins: [JeecgListMixin],
  components: {
    TableList,
    AssessModal,
    TeacherAssessment,
    DetailedReport,
  },
  data() {
    return {
      tabKey: 1,
      currPage: 1,
      queryParam: {},
      tabPaneConfig: [
        {
          tab: '心理测评',
          columns: [
            {
              title: '序号',
              dataIndex: 'index',
              align: 'center',
            },
            {
              title: '计划名称',
              dataIndex: 'planId_dictText',
              align: 'center',
            },
            {
              title: '班级',
              dataIndex: 'className',
              align: 'center',
            },
            {
              title: '学生',
              dataIndex: 'studentName',
              align: 'center',
            },
            {
              title: '重点关爱名单',
              dataIndex: 'careList',
              align: 'center',
              customRender: (_, record) => {
                return record.careList > 0 ? '是' : '否'
              },
            },
            {
              title: '异常项',
              dataIndex: 'abnormalItems',
              align: 'center',
              customRender: (_, record) => {
                return record.abnormalItems.length > 30 ? (
                  <a-tooltip>
                    <template slot="title">{record.abnormalItems}</template>
                    {record.abnormalItems.slice(0, 30) + '...'}
                  </a-tooltip>
                ) : (
                  record.abnormalItems
                )
              },
            },
            // {
            //   title: '班主任反馈',
            //   dataIndex: 'abnormalItems',
            //   align: 'center',
            //   customRender: (_, record) => {
            //     return (
            //       <div onClick={() => this.viewFeedback(record)} style="cursor: pointer">
            //         查看
            //       </div>
            //     )
            //   },
            // },
            {
              title: '操作',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
            ,
          ],
          tableData: [],
          loading: false,
          pagination: { ...tablePagination },
        },
      ],
      url: {
        list: '/schoolEvaluationPlanResult/list',
        importExcelUrl: '',
        exportXlsUrl: '/schoolEvaluationPlanResult/exportXls',
      },
      warnCategoryOpts: [
        {
          label: '全部',
          value: 0,
        },
        {
          label: '重点关爱学生',
          value: 1,
        },
        {
          label: '提醒学生',
          value: 2,
        },
      ],
      warnLvOpts: [
        {
          label: '正常',
          value: 0,
        },
        {
          label: '一级',
          value: 1,
        },
        {
          label: '二级',
          value: 2,
        },
        {
          label: '三级',
          value: 3,
        },
      ],
      assessStatusOpts: [
        {
          label: '已评估',
          value: 0,
        },
        {
          label: '未评估',
          value: 1,
        },
      ],
      archivesData: {},
    }
  },
  created() {
    // this.loadData()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    // 分页变化
    handleTableChange(page) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', page)
      this.loadData()
    },
    // 查询
    queryTable() {
      console.log('查询条件--', this.queryParam)
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', { ...tablePagination })
      this.loadData()
    },
    searchName: simpleDebounce(function (event) {
      this.loadData()
    }, 500),
    loadData() {
      let params = {
        pageNo: this.tabPaneConfig[this.tabKey - 1].pagination.current,
        pageSize: this.tabPaneConfig[this.tabKey - 1].pagination.pageSize,
        ...this.queryParam,
      }
      switch (this.tabKey) {
        case 1:
          this.$set(this.url, 'list', '/schoolEvaluationPlanResult/list')
          params = { ...params }
          break
      }
      this.getTableData(params)
    },
    getTableData(params) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', true)
      getAction(this.url.list, params)
        .then((res) => {
          console.log('获取列表数据--', res)
          if (res.success) {
            const tableData = res.result.records.length
              ? res.result.records.map((item, index) => ({
                  ...item,
                  index: index + 1,
                }))
              : []
            this.$set(this.tabPaneConfig[this.tabKey - 1], 'tableData', tableData)
            this.$set(this.tabPaneConfig[this.tabKey - 1].pagination, 'total', res.result.total)
          }
        })
        .finally(() => {
          this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', false)
        })
    },
    assessClick(data) {
      this.$refs.assessModalRef.showModal(data)
    },
    seeReport(record){
      this.$refs.detailedReportRef.showModal(record)
    },
    viewArchives(record) {
      this.$router.push({
        path: '/school/mentalHealth/ArchivesViewPage',
        query: {
          studentId: record.studentId,
        },
      })
    },
    viewFeedback(record) {
      console.log('查看信息：', record)
      this.$refs.teacherAssessmentRef.showModal(record)
    },
  },
}
</script>
<style scoped lang="less">
.action-detail {
  min-width: 100px !important;
  color: #0077fa !important;
  cursor: pointer !important;
}
</style>
